{{#with attributes}}
  <div{{#if styles}} id="locale-html-atom-{{../cid}}" class="{{obj_values_to_string styles}}"{{/if}}>
    {{#each content}}
      {{#ifIsString this}} 
        {{{this}}}
      {{else}} 
        <span class="inline-atom" data-region="atom-{{merge-code}}-{{../../cid}}"></span>
      {{/ifIsString}}
    {{/each}}
  </div> 
{{/with}}